import { Component, Input, OnInit } from '@angular/core';
import { Merchant } from "../../../common/interfaces/Merchant";
import { Router } from "@angular/router";

@Component({
  selector: 'merchant-list-item',
  templateUrl: './merchant-list-item.component.html',
  styleUrls: ['./merchant-list-item.component.scss']
})
export class MerchantListItemComponent implements OnInit {

  @Input() merchant!: Merchant
  image: string = ""

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.image = this.merchant.profilePictureURL ?? ""
  }

  viewMerchant() {
    this.router.navigate(['/page', this.merchant.slug])
  }

  setDefaultPlaceholder() {
    this.image = 'assets/merchant-placeholder.svg'
  }
}
